import {
  DIVISION_DETAILS,
  FILTER_BY_PART,
  FILTER_BY_VENDOR,
  LOCATION_DETAILS,
  PART_DETAILS,
  VENDOR_DETAILS,
  VENDOR_DETAILS_SUB_FILTER,
  VENDOR_DETAILS_SUB_FILTER_WITH_DATES,
} from "../../config/apiList";
import { contentType, methodType } from "../../config/auth";
import { apiRequest } from "../../utility/apiWrapper";

export const getDivisionDetails = () => {
  const requestURL = DIVISION_DETAILS;

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: {},
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getVendorDetails = (
  divisionList = null,
  deptList = null,
  page,
  search
) => {
  let requestURL = VENDOR_DETAILS;
  let obj = {};
  if (divisionList && divisionList.length) {
    obj["division_list"] = divisionList.join(",");
  }

  if (deptList && deptList.length) {
    obj["dept_list"] = deptList.join(",");
  }

  if (page) {
    obj["page"] = page;
  }

  if (search) {
    obj["search"] = search;
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getDivisionDeptByVendor = (vendorList = null) => {
  const requestURL = FILTER_BY_VENDOR;
  let obj = {};

  if (vendorList && vendorList.length) {
    obj["vendor_list"] = vendorList.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getPartDetails = (
  deptList = null,
  vendorList = null,
  page,
  search
) => {
  let requestURL = PART_DETAILS;
  let obj = {};
  if (deptList && deptList.length) {
    obj["dept_list"] = deptList.join(",");
  }

  if (vendorList && vendorList.length) {
    obj["vendor_list"] = vendorList.join(",");
  }

  if (page) {
    obj["page"] = page;
  }

  if (search) {
    obj["search"] = search;
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getDivisionDeptVendorByPart = (partList = null) => {
  const requestURL = FILTER_BY_PART;
  let obj = {};

  if (partList && partList.length) {
    obj["vendor_list"] = partList.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getVendorSubFilterDetails = (
  deptList = null,
  division_list = null,
  page,
  search
) => {
  const requestURL = VENDOR_DETAILS_SUB_FILTER;
  let obj = {};

  if (deptList && deptList.length) {
    obj["dept_list"] = deptList.join(",");
  }

  if (division_list && division_list.length) {
    obj["division_list"] = division_list.join(",");
  }

  if (page) {
    obj["page"] = page;
  }

  if (search) {
    obj["search"] = search;
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getLocationDetails = () => {
  const requestURL = LOCATION_DETAILS;

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: {},
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getVendorSubFilterDetailsWithDates = (
  startDate,
  endDate,
  deptList = null,
  division_list = null,
  page,
  search,
) => {
  const requestURL = VENDOR_DETAILS_SUB_FILTER_WITH_DATES;
  let obj = { from_date: startDate, to_date: endDate };

  if (deptList && deptList.length) {
    obj["dept_list"] = deptList.join(",");
  }

  if (division_list && division_list.length) {
    obj["division_list"] = division_list.join(",");
  }

  if (page) {
    obj["page"] = page;
  }

  if (search) {
    obj["search"] = search;
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};
